import { AppointmentState } from '@servicetitan/cp-ui';
import { JobListItemStatus } from '../api/portal-dashboard.api';
import { JobAppointmentItemStatus } from '../api/portal-jobs.api';

export const getAppointmentState = (
    status: JobAppointmentItemStatus | JobListItemStatus
): AppointmentState => {
    switch (status) {
        case JobAppointmentItemStatus.Scheduled:
        case JobListItemStatus.Scheduled:
            return AppointmentState.Scheduled;
        case JobAppointmentItemStatus.Dispatched:
        case JobListItemStatus.InProgress:
        case JobAppointmentItemStatus.Working:
            return AppointmentState.InProgress;
        case JobListItemStatus.Completed:
        case JobAppointmentItemStatus.Completed:
            return AppointmentState.Completed;
        case JobAppointmentItemStatus.Canceled:
        case JobListItemStatus.Canceled:
        case JobAppointmentItemStatus.OnHold:
        case JobListItemStatus.OnHold:
            return AppointmentState.CanceledOrOnHold;
        default:
            return AppointmentState.Scheduled;
    }
};
